<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <InformationsFormation />
  <ChoixTypeModule />
  <BasicRedirection
    :show-if="!!moduleEnCours"
    @after-scroll="définirModuleEnCours(null)"
  >
    <template #topAnchor>
      <ListeModules />
    </template>
    <template #bottomAnchor>
      <Module />
    </template>
  </BasicRedirection>
</template>

<script setup lang="ts">
  import ChoixTypeModule from './modal/ChoixTypeModule.vue'
  import ListeModules from './sections/liste/ListeModulesSection.vue'
  import Module from './sections/module/ModuleSection.vue'
  import InformationsFormation from './sections/informations/InformationsFormation.vue'
  import { inject } from 'vue'
  import { type ModuleAction, ModuleActionKey } from './useModuleActions'

  const { moduleEnCours, définirModuleEnCours } = inject<ModuleAction>(ModuleActionKey)!
</script>
